import { partition, sortBy } from 'lodash-es'

import { LOCATION_STATUSES_SORT_VALUES } from '../../brands/constants'

const sortLocationByStatusComparator = location =>
  LOCATION_STATUSES_SORT_VALUES[location.status].sortValue

const sortLocationsForBrandGatewayTask = (locations, currentView) => {
  const locationsSortedById = sortBy(locations, 'id')

  const [
    locationsRequiringReview,
    locationsNotRequiringReview,
  ] = partition(locationsSortedById, location =>
    currentView.modifiedLocationIds.includes(Number(location.id)),
  )

  const locationsNotRequiringReviewSortedByStatus = sortBy(
    locationsNotRequiringReview,
    sortLocationByStatusComparator,
  )

  return [
    ...locationsRequiringReview,
    ...locationsNotRequiringReviewSortedByStatus,
  ]
}

export default sortLocationsForBrandGatewayTask
